import { DatePicker, Form, Input, Button, Row, Col, Select, Popconfirm, Tooltip, SelectProps, Modal } from 'antd';
import { TableOutlined, DeleteOutlined, SaveOutlined, PlusOutlined } from '@ant-design/icons';
import { t } from 'i18next';
import React, { useEffect, useRef, useState } from 'react';
import { ISupplierData } from '../../../../interfaces/ISupplierData';
import { IBrandData } from '../../../../interfaces/IBrandData';
import MUIDatagrid from '../../../../AltisComponent/MUIDataGrid';
import AltisDataGrid, { IAltisDataGridColumns } from '../../../../AltisComponent/AltisDataGrid';
import HTTPService from '../../../../utils/makerequest';
import { Toast } from 'primereact/toast';
import AddSupplier from '../../SupplierManagement/AddSupplier';
import { IAuthentication } from '../../../../interfaces/authentication';
import { StateLoader } from '../../../../redux/StateLoader';
import { IItemData } from '../../../../interfaces/IItemData';
import AddBrand from '../../BrandManagement/AddBrand';
import Dropdown from '../../../../AltisComponent/Dropdown';

const SubPartsTab = ({ inventoryId, setTabIndex, companyId }) => {
    const [selectedActivityType, setSelectedActivityType] = useState(null);
    const [supplierData, setSupplierData] = useState<ISupplierData[]>([]);
    const [brandData, setBrandData] = useState<IBrandData[]>([]);
    const [tableData, setTableData] = useState<any[]>([]);
    const [isModalVisibleSupplier, setIsModalVisibleSupplier] = useState(false);
    const [selectedCompany, setSelectedCompany] = useState<number | undefined>(undefined);
    const [isModalVisibleBrand, setIsModalVisibleBrand] = useState(false);
    const [itemData, setItemData] = useState<IItemData>({});
    const [form] = Form.useForm();
    const toast = useRef<any>(null);

    const loader = new StateLoader();
    const user: IAuthentication = loader.loadAuthState();

    useEffect(() => {
        if (inventoryId !== 0) {
            fetchSupplier(companyId);
            SubPartsById(inventoryId);
        }
    }, [inventoryId]);

    const SubPartsById = async (inventoryId: number) => {
        try {
            const res = await HTTPService.GET(`/Inventory/subPartById?inventoryId=${inventoryId}`);
            if (res.status === 200 && res.data) {
                const formattedData = res.data.map((item: any, index: number) => ({
                    id: index + 1,
                    subPartName: item.subPartName,
                    partNo: item.partNo,
                    supplierName: item.supplierTBL?.supplierName,
                    brand: item.brandTBL?.brandName,
                    supplierId: item.supplierId,
                    brandId: item.brandId,
                    description: item.description,
                    brandTBL: item.brandTBL,
                    supplierTBL: item.supplierTBL
                }));

                setTableData(formattedData);
            }
        } catch (error) {
            console.error("Error:", error);
            toast.current?.show({
                severity: 'error',
                summary: t('mistake'),
                detail: t('error_message'),
                life: 3000
            });
        }
    };

    const fetchBrandByCompany = async (companyId: number) => {
        try {
            const result = await HTTPService.GETBrandNames(companyId);
            setBrandData(result);
        } catch (error) {
            console.error(error);
            toast.current?.show({
                severity: 'error',
                summary: t('mistake'),
                detail: t('error_message'),
                life: 3000
            });
        }
    };


    const fetchSupplier = async (companyId: number) => {
        try {
            const result = await HTTPService.GETSupplierNames(companyId);
            setSupplierData(result);
        } catch (error) {
            console.error(error);
            toast.current?.show({
                severity: 'error',
                summary: t('mistake'),
                detail: t('error_message'),
                life: 3000
            });
        }
    };

    const columns: IAltisDataGridColumns[] = [
        {
            title: t('subPartName'),
            key: 'subPartName',
            placeHolder: t('subPartName'),
            inputType: "input",
        },
        {
            title: t('partNo'),
            key: 'partNo',
            placeHolder: t('partNo'),
            inputType: "input",
        },
        {
            title: t('supplier_name'),
            key: 'supplierName',
            placeHolder: t('supplier_name'),
            inputType: "operations",
            render: (_, record) => {
                const supplier = supplierData.find(s => s.supplierId === record.supplierId);
                return supplier?.supplierName;
            }
        },
        {
            title: t('brand'),
            key: 'brand',
            placeHolder: t('brand'),
            inputType: "operations",
            render: (_, record) => {
                return record.brandTBL?.brandName || record.brand || '';
            }
        },
        {
            title: t('Operations'),
            key: 'operations',
            placeHolder: t('Operations'),
            inputType: "operations",
            render: (_, record) => (
                <Popconfirm
                    title={t('delete_confirm')}
                    onConfirm={() => handleDeleteRow(record.id)}
                    okText={t('yes')}
                    cancelText={t('no')}
                >
                    <Button
                        size='small'
                        icon={<DeleteOutlined />}
                        onClick={(e) => { e.stopPropagation(); }}
                        style={{ width: '60px', borderRadius: '70px' }}
                    />
                </Popconfirm >
            )
        },
    ];

    const filterOption: SelectProps<any>['filterOption'] = (input, option) => {
        return (option?.children as unknown as string).toLowerCase().includes(input.toLowerCase());
    };

    const handleAddToTable = (values: any) => {
        const supplier = supplierData.find(s => s.supplierId === values.supplierId);
        const brand = brandData.find(b => b.brandId === values.brandId);

        const newRow = {
            id: tableData.length + 1,
            subPartName: values.subPartName,
            partNo: values.partNo,
            supplierName: supplier?.supplierName || '',
            brand: brand?.brandName || '',
            supplierId: values.supplierId,
            brandId: values.brandId || null,
            description: values.description
        };

        setTableData([...tableData, newRow]);
        form.resetFields(Object.keys(values).filter(key => key !== "subPartName"));
    };

    const handleDeleteRow = (id: number) => {
        setTableData(prev => prev.filter(item => item.id !== id));
        toast.current?.show({
            severity: 'success',
            summary: t('successful'),
            detail: t('delete_success'),
            life: 3000
        });
    };

    const subpartRegister = async () => {
        try {
            await form.validateFields();

            if (tableData.length === 0) {
                toast.current?.show({
                    severity: 'warn',
                    summary: t('Warning'),
                    detail: t('no_data_to_save'),
                    life: 3000
                });
                return;
            }

            const formattedData = tableData.map(row => ({
                subPartName: row.subPartName,
                partNo: row.partNo,
                supplierId: Number(row.supplierId),
                brandId: Number(row.brandId) || 0,
                description: row.description || ''
            }));

            const response = await HTTPService.POST(
                `/Inventory/registerSubPart?inventoryId=${inventoryId}`,
                formattedData
            );

            if (response.status === 200) {
                toast.current?.show({
                    severity: 'success',
                    summary: t('successful'),
                    detail: t(response.data),
                    life: 3000
                });

                //setTabIndex(window.location.pathname.includes('/admin/update-inventory') ? 3 : 2);
                //setTableData([]);
            }
        } catch (error: any) {
            toast.current?.show({
                severity: 'error',
                summary: t('mistake'),
                detail: error?.response?.data,
                life: 3000
            });
        }
    };


    const showModalSupplier = () => {
        setIsModalVisibleSupplier(true);
    };

    const showModalBrand = () => {
        setIsModalVisibleBrand(true);
    };


    const handleCancelSupplier = () => {
        setIsModalVisibleSupplier(false);
        fetchSupplier(selectedCompany || user.companyId);
    };


    const savedNewSupplier = (supplier: ISupplierData) => {
        // Form'da yeni tedarikçiyi seç
        form.setFieldsValue({ supplierId: supplier.supplierId });

        // Tedarikçi listesini güncelle
        setSupplierData(prevSupplierData => [...prevSupplierData, supplier]);

        // Modal'ı kapat
        setIsModalVisibleSupplier(false);

        // Başarılı mesajı göster
        toast.current?.show({
            severity: 'success',
            summary: t('successful'),
            detail: t('supplier_added_successfully'),
            life: 3000
        });
    };

    const handleCancelBrand = () => {
        setIsModalVisibleBrand(false);
        fetchBrandByCompany(selectedCompany || user.companyId);
    };


    const savedNewBrand = (brand: IBrandData) => {
        form.setFieldsValue({ brandId: brand.brandId });

        setBrandData(prevBrandData => [...prevBrandData, brand]);

        setIsModalVisibleBrand(false);

        toast.current?.show({
            severity: 'success',
            summary: t('successful'),
            detail: t('brand_added_successfully'),
            life: 3000
        });
    };


    return (
        <>
            <Toast ref={toast} />
            <div>
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleAddToTable}
                >
                    <Form.Item
                        label={t('subPartName')}
                        name="subPartName"
                        rules={[{ required: true, message: t('subPartName') }]} >
                        <Input
                            placeholder={t('subPartName')}
                            style={{ borderRadius: '5px' }}
                            onBlur={(e) => {
                                const value = e.target.value.trim();
                                if (value && !e.target.dataset.toastShown) {
                                    toast.current?.show({
                                        severity: 'warn',
                                        summary: t('Warning'),
                                        detail: t('required_subpart'),
                                        life: 3000
                                    });
                                    e.target.dataset.toastShown = 'true';
                                }
                            }}
                        />
                    </Form.Item>

                    <Form.Item
                        label={t('partNo')}
                        name="partNo"
                        rules={[{ required: false, message: t('partNo') }]} >
                        <Input placeholder={t('partNo')} style={{ borderRadius: '5px' }} />
                    </Form.Item>

                    <Form.Item
                        name='supplierId'
                        label={
                            <Tooltip title={t('select_supplier_description')}>
                                {t('supplier_name')}
                            </Tooltip>
                        }
                        rules={[{ required: false, message: t('supplier_name') }]}
                        style={{ marginBottom: '8px' }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <div style={{ flex: 1 }}>
                                <Dropdown
                                    placeholder={t('supplier_name')}
                                    style={{ width: '100%' }}
                                    onFocus={() => fetchSupplier(companyId)}
                                    dataSource={supplierData}
                                    labelKey="supplierName"
                                    valueKey="supplierId"
                                    includeEmptyOption={false}
                                    onChange={(value) => form.setFieldsValue({ supplierId: value })}
                                    value={form.getFieldValue('supplierId')}
                                />
                            </div>
                            <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={showModalSupplier}
                                style={{ flexShrink: 0, marginTop: -10 }}
                            />
                        </div>
                    </Form.Item>


                    <Form.Item
                        name='brandId'
                        label={
                            <Tooltip title={t('select_brand_description')}>
                                {t('brand')}
                            </Tooltip>
                        }
                        rules={[{ required: false, message: t('brand') }]}
                        style={{ marginBottom: '8px' }}
                    >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <div style={{ flex: 1 }}>
                                <Dropdown
                                    placeholder={t('brand')}
                                    style={{ width: 'calc(100% - 0px)' }}
                                    onFocus={() => fetchBrandByCompany(companyId)}
                                    dataSource={brandData}
                                    labelKey="brandName"
                                    valueKey="brandId"
                                    includeEmptyOption={false}
                                    onChange={(value) => form.setFieldsValue({ brandId: value })}
                                    value={form.getFieldValue('brandId')}
                                />
                            </div>
                            <Button
                                type="primary"
                                icon={<PlusOutlined />}
                                onClick={showModalBrand}
                                style={{ marginLeft: '8px', marginTop: -12 }}
                            />
                        </div>
                    </Form.Item>


                    <Form.Item
                        label={t('description_activity')}
                        name="description"
                        rules={[{ required: false, message: t('enter_description') }]}
                        style={{ marginTop: '8px' }} // Reduced top margin
                    >
                        <Input placeholder={t('enter_description')} style={{ borderRadius: '5px' }} />
                    </Form.Item>
                </Form>

                <Button
                    type="primary"
                    onClick={() => form.submit()}
                    style={{
                        borderRadius: '5px',
                        marginBottom: '30px'
                    }}
                >
                    <TableOutlined style={{ fontSize: '18px' }} />
                    <span>{t('addTable')}</span>
                </Button>

                <AltisDataGrid
                    data={tableData}
                    columns={columns}
                    onChange={() => { }}
                    total={tableData.length}
                />

                <Form.Item style={{ marginTop: '15px' }}>
                    <Row gutter={[8, 8]} justify="end" align="middle">
                        <Col xs={12} sm={12} md={4}>
                            <Button
                                block
                                type="primary"
                                onClick={subpartRegister}
                                style={{
                                    height: 64,
                                    backgroundColor: 'transparent',
                                    color: '#1890ff',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    padding: '0 10px',
                                    border: 'none',
                                    transition: 'all 0.3s ease',
                                    cursor: 'pointer'
                                }}
                                onMouseEnter={(e) => {
                                    e.currentTarget.style.transform = 'scale(1.05)';
                                    e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                                    e.currentTarget.style.color = '#40a9ff';
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.style.transform = 'scale(1)';
                                    e.currentTarget.style.boxShadow = 'none';
                                    e.currentTarget.style.color = '#1890ff';
                                }}
                            >
                                <SaveOutlined style={{ fontSize: 20 }} />
                                <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
                                    {t('save')}
                                </span>
                            </Button>
                        </Col>
                    </Row>
                </Form.Item>
            </div >

            <Modal
                visible={isModalVisibleSupplier}
                footer={null}
                onCancel={handleCancelSupplier}
                width={790}
                bodyStyle={{ padding: '0px', display: 'flex', flexDirection: 'column', height: '35vh' }}
            >
                <div style={{ flex: 1 }}>
                    <AddSupplier cancelModal={handleCancelSupplier} savedObj={savedNewSupplier}
                        companyId={companyId} supplierName={itemData.supplierName}
                    />
                </div>
            </Modal>

            <Modal
                visible={isModalVisibleBrand}
                footer={null}
                onCancel={handleCancelBrand}
                width={790}
                bodyStyle={{ padding: '0px', display: 'flex', flexDirection: 'column', height: '35vh' }}
            >
                <div style={{ flex: 1 }}>
                    <AddBrand cancelModal={handleCancelBrand} savedObj={savedNewBrand}
                        companyId={companyId} brandName={itemData.brandName}
                    />
                </div>
            </Modal>


        </>

    );
};

export default SubPartsTab;
